module.exports = __webpack_public_path__ + "img/worklate-title.3f5b5f25.svg";